import React from "react";
import NewsList from "../Components/Ambassador/News/NewsList";

const AmbassadorNewsPage: React.FC = () => <NewsList />;

export default AmbassadorNewsPage;
